export default "__VITE_ASSET__BI9Caf97__"